import React, { useState, useEffect } from 'react';
import './SilverRateDropdown.css';
import axios from 'axios';

const SilverRateDropdownComponent = ({ mobile }) => {
  const [prices, setPrices] = useState({ gold: null, silver: null });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const response = await axios.get('https://sales.nkvairamaaligai.com/api/v1/rates');
        setPrices({
          gold: response.data.Rate,
          silver: response.data.SILVERRATE,
        });
        setLoading(false);
      } catch (err) {
        console.warn('Primary API failed, falling back to local rates:', err.message);
        try {
          const localResponse = await axios.get(
            'https://sales.nkvairamaaligai.com/api/v1/rates',
            { headers: { 'Content-Type': 'application/json' } }
          );
          const rates = localResponse.data;

          if (rates && rates.length > 0) {
            const latestRate = rates.sort(
              (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
            )[0];
            setPrices({
              gold: latestRate.goldRate,
              silver: latestRate.silverRate,
            });
            setLoading(false);
          } else {
            setError('No rates available');
            setLoading(false);
          }
        } catch (localErr) {
          console.error('Failed to fetch local rates:', localErr);
          setError('Rs:106');
          setLoading(false);
        }
      }
    };

    fetchPrices();
  }, []);

  if (loading) {
    return <div className={mobile ? "silver-loading-mobile" : "silver-loading-desktop"}>...</div>;
  }

  if (error) {
    return <div className={mobile ? "silver-error-mobile" : "silver-error-desktop"}>{error}</div>;
  }

  return (
    <div className={`silver-dropdown-container ${mobile ? 'mobile' : ''}`}>
      {!mobile && <div className="silver-rate-label"></div>}
      <div className="silver-dropdown">
        <button className={`silver-dropdown-toggle ${mobile ? 'mobile' : ''}`}>
          <span>{mobile ? `S:₹${prices.silver}` : `SILVER 1G: ₹${prices.silver}`}</span>
        </button>
      </div>
    </div>
  );
};

export default SilverRateDropdownComponent;